<template>
  <div class="main" :style="{ overflow: overflow , 'background-color': '#fff'}">
    <div
      v-bind:style="{ height: '100px', 'background-color': '#fff' }"
    ></div>
    <HeaderComponent
        :text="$t('text.book')"
        backgroundColor="#fff"
        textColor="#333"
    />
    <Transition appear name="fade">
        <div class="body-container">
            <p v-if="!isLoggedIn" style="font-size: 1rem; text-align: center;margin-left:10px;margin-right:10px;">
                {{ $t('text.book_login_text_1') }} <a :href="'/register?redirect=' + $router.currentRoute.fullPath">{{ $t('text.book_login_text_2') }}</a>{{ $t('text.book_login_text_3') }} <a :href="'/login?redirect=' + $router.currentRoute.fullPath">{{ $t('text.book_login_text_4') }}</a>
            </p>
            <br>
            <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
                <b-spinner
                    variant="dark"
                    label="Spinning"
                    class="login-loader"
                ></b-spinner>
            </div>
            
            <b-form @submit="onSubmit" v-if="!loading">
                <div class="booking-section-container">
                    <p class="form-section-header-text">{{ $t('text.booking') }}</p>

                    <div 
                        v-if="form.cabin != null && form.cabin != 0" 
                        style="text-align:right;margin-bottom:-25px;color:#007bff"
                    >
                        <a @click="goToCabin()">{{ $t('text.cabin_read_more') }}</a>
                    </div>
                    <b-form-group id="input-group-5" :label="$t('text.cabin')" label-for="input-5">
                        <b-form-select
                        id="input-5"
                        v-model="form.cabin"
                        :options="cabins"
                        required
                        ></b-form-select>
                    </b-form-group>
                    <div v-if="loading_cabin_prices" style="text-align: center; margin-top:80px;">
                        <b-spinner
                            variant="dark"
                            label="Spinning"
                            class="login-loader"
                        ></b-spinner>
                    </div>
                    <b-form-group 
                        v-if="!loading_cabin_prices && form.cabin!=null" 
                        id="input-group-8" 
                        :label="$t('text.dates')" 
                        label-for="input-8"
                    >
                        <HotelDatePicker
                            :alwaysVisible="false"
                            showWeekNumbers
                            :firstDayOfWeek="1"
                            :showYear="true"
                            :i18n="localeStrings"
                            :disabledDates="disabledDates"  
                            :startingDateValue="form.start_date"
                            :endingDateValue="form.end_date"
                            :hoveringTooltip="false"
                            @check-in-changed="setStartDate($event)"
                            @check-out-changed="setEndDate($event)"
                        />
                        <p class="error-label" v-if="show_date_validation_text">
                            {{ $t('text.'+date_validation_text) }}
                        </p>
                        <div v-if="form.cabin!=null && price>0 && !isAdmin && !show_date_validation_text" >
                            <p v-if="!price_loading" class="price-text">
                                {{ $t('text.price') }}<br>
                                <span style="color: #20c997;">
                                    {{ price }} {{ $t('text.sek') }}
                                </span>
                            </p>
                            <div v-if="price_loading" style="text-align:left;margin-bottom:20px;">
                                <p class="price-text" style="float:left;">{{ $t('text.price') }}:</p>
                                <b-spinner variant="dark" label="Spinning" style="margin-left:10px;"></b-spinner>
                            </div>
                        </div>

                        <b-form-group v-if="isAdmin" :label="$t('text.price')" class="price-text">
                            <b-form-input
                            id="input-4"
                            v-model="price"
                            type="number"
                            :placeholder="$t('text.price')"
                            ></b-form-input>
                        </b-form-group>
                    </b-form-group>
                
                    <div style="height: 20px;"></div>
                    <div style="height: 1px;background-color:#ccc;"></div>
                    <div style="height: 30px;"></div>

                    
                    <p v-if="!bookAsUser" class="form-section-header-text">{{ $t('text.your_information') }}</p>
                    <p v-else class="form-section-header-text">{{ $t('text.additional_information') }}</p>

                    <b-form-group v-if="isAdmin">
                        <b-form-checkbox
                        id="checkbox-2"
                        v-model="enter_information"
                        >
                            {{$t('text.enter_information')}}
                        </b-form-checkbox>
                    </b-form-group>

                    <b-form-group v-if="isAdmin && bookAsUser" id="input-group-0" :label="$t('text.user')" label-for="input-5">
                        <b-form-select
                        id="input-0"
                        v-model="user"
                        :options="users"
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group id="input-group-1" :label="$t('text.first_name')" label-for="input-1" v-if="!bookAsUser">
                        <b-form-input
                        id="input-1"
                        v-model="form.first_name"
                        :placeholder="$t('text.enter_first_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" :label="$t('text.last_name')" label-for="input-2" v-if="!bookAsUser">
                        <b-form-input
                        id="input-2"
                        v-model="form.last_name"
                        :placeholder="$t('text.enter_last_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="!bookAsUser" id="input-group-3" :label="$t('text.email_address')" label-for="input-3">
                        <b-form-input
                        id="input-3"
                        v-model="form.email"
                        type="email"
                        :placeholder="$t('text.enter_email')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="!bookAsUser" id="input-group-4" :label="$t('text.phone')" label-for="input-4">
                        <b-form-input
                        id="input-4"
                        v-model="form.phone"
                        type="number"
                        :placeholder="$t('text.enter_phone')"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="isFamily" id="input-group-10" label-for="input-10">
                        <b-form-checkbox
                        id="checkbox-1"
                        v-model="friends_included"
                        >
                            {{$t('text.friends_included')}}
                        </b-form-checkbox>
                    </b-form-group>

                    <b-form-group id="input-group-6" :label="$t('text.memory_note')" label-for="input-6">
                        <b-form-textarea
                        id="input-4"
                        v-model="form.notes"
                        type="text"
                        :placeholder="$t('text.message')"
                        ></b-form-textarea>
                    </b-form-group>
                
                    <b-form-group v-if="!isLoggedIn" id="input-group-10" label-for="input-10">
                        <b-form-checkbox v-model="terms_accepted" required>
                            <p style="font-size:12px;">{{ $t('text.terms_of_condition_booking') }}</p>
                        </b-form-checkbox>
                    </b-form-group>

                    <p style="font-size:12px;margin-bottom:30px;">{{ $t('text.booking_payment_information') }}</p>

                    <b-button :disabled="!enableSubmitButton" type="submit" variant="primary">{{ $t('text.book') }}</b-button>
                </div>
            </b-form>
        </div>
    </Transition>
    
  </div>
</template>

<script>
import HotelDatePicker from "vue-hotel-datepicker2";
import "vue-hotel-datepicker2/dist/vueHotelDatepicker2.css";

import HeaderComponent from "../components/HeaderComponent.vue";
import BookingApiService from "../../services/booking_api_service";
import UserApiService from "../../services/user_api_service";
import CabinApiService from "../../services/cabin_api_service";
import CabinPrice from "../../models/cabin_price";
import Booking from "../../models/booking";

import DateHelper from "../../helpers/date";


export default {
    name: "BookingPage",
    components: {
        HeaderComponent,
        HotelDatePicker
    },
    data() {
        return {
            form: {
                email: '',
                phone: '',
                first_name: '',
                last_name: '',
                cabin: null,
                start_date: null,
                end_date: null,
                notes: ''
            },
            user: null,
            terms_accepted: false,
            friends_included: false,
            enter_information: false,
            cabin_prices: [],
            users: [{ text: this.$t('text.me'), value: null }],
            overflow: "visible",
            price: 0,
            loading: false,
            price_loading: false,
            loading_cabin_prices: false,
            form_set_from_query: false,
            bookings: [],
            date_validation_text: "",
            show_date_validation_text: false,
            locale_se: {
                "night": "Natt",
                "nights": "Nätter",
                "week": "vecka",
                "weeks": "veckor",
                "day-names": ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"],
                "check-in": "Check-in",
                "check-out": "Check-out",
                "month-names": [
                    "Januari",
                    "Februari",
                    "Mars",
                    "April",
                    "Maj",
                    "Juni",
                    "Juli",
                    "Augusti",
                    "September",
                    "Oktober",
                    "November",
                    "December",
                ],
                "tooltip": {
                    "halfDayCheckIn": "Tillgänglig CheckIn",
                    "halfDayCheckOut": "Tillgänglig CheckOut",
                    "saturdayToSaturday": "Endast Lördag till Söndag",
                    "sundayToSunday": "Endast Söndag till Söndag",
                    "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
                },
            },
            locale_en: {
                "night": "Night",
                "nights": "Nights",
                "week": "week",
                "weeks": "weeks",
                "day-names": ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"],
                "check-in": "Check-in",
                "check-out": "Check-out",
                "month-names": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                "tooltip": {
                    "halfDayCheckIn": "Available CheckIn",
                    "halfDayCheckOut": "Available CheckOut",
                    "saturdayToSaturday": "Only Saturday to Saturday",
                    "sundayToSunday": "Only Sunday to Sunday",
                    "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
                },
            },
        }
    },
    watch: {
        selected_cabin: function() {
            this.fetchCabinPrices();
            if (this.form_set_from_query) {
                this.form_set_from_query = false;
                return;
            }
            this.form.start_date = null;
            this.form.end_date = null;
            this.price = 0;
            if (this.$route.query.cabin) {
                this.$router.push({path: "/book", query: {}});
            }
        }, 
        friends_included: function() {
            if (this.form.start_date && this.form.end_date) {
                this.fetchBookingPrice();
            }
        },
        user: function() {
            if (this.form.start_date && this.form.end_date) {
                this.fetchBookingPrice();
            }
        },
        enter_information: function() {
            if (this.form.start_date && this.form.end_date) {
                this.fetchBookingPrice();
            }
        },
    },
    computed: {
        isLoggedIn: function() {
            return (
                this.$store.getters.token_valid &&
                this.$store.getters.isLoggedIn
            );
        },
        validateEmail() {
            var re = /\S+@\S+\.\S+/;
            return this.form.email.length == 0 || re.test(this.form.email);
        },
        selected_cabin() {
            return this.form.cabin;
        },
        cabins() {
            if (this.isLoggedIn && this.$store.getters.user.clearance > 1) {
                return [{ text: this.$t('text.select_cabin'), value: null }, { text: this.$t('text.family_cabin'), value: 0}, { text: this.$t('text.large_cabin'), value: 1}, { text: this.$t('text.small_cabin'), value: 2}];
            }
            return [{ text: this.$t('text.select_cabin'), value: null }, { text: this.$t('text.large_cabin'), value: 1}, { text: this.$t('text.small_cabin'), value: 2}];
        },
        localeStrings() {
            return (this.$root.$i18n.locale == "en" ? this.locale_en : this.locale_se);
        },
        disabledDates() {
            var dates = []
            const bookings = this.bookings.filter((booking) => {return booking.cabin == this.form.cabin})
            for (var i in bookings) {
                dates = dates.concat(DateHelper.getDaysArray(bookings[i].start_date, bookings[i].end_date))
            }
            return dates
        },
        enableSubmitButton() {
            return (
                ( 
                    this.bookAsUser || (
                        this.form.first_name != '' &
                        this.form.last_name != '' &
                        this.form.email != ''
                    )
                ) &
                (this.isLoggedIn || this.terms_accepted) &
                this.form.cabin != null &
                this.form.start_date != null &
                this.form.end_date != null &
                this.correctDatesSelected()
            );
        },
        isFamily() {
            return (
                this.$store.getters.token_valid &&
                this.$store.getters.isLoggedIn && 
                this.$store.getters.user.clearance > 0
            );
        },
        isFamilyBooking() {
            if (this.bookAsUser) {
                if (this.user) {
                    return this.user.clearance > 0;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        isAdmin() {
            return (
                this.$store.getters.token_valid &&
                this.$store.getters.isLoggedIn && 
                this.$store.getters.user.clearance > 2
            );
        },
        bookAsUser() {
            return (this.isLoggedIn && !this.enter_information)
        },
    },
    methods: {
        setStartDate(date) {
            this.price = 0;
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.form.start_date = date;
        },
        setEndDate(date) {
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.form.end_date = date;
            if (this.form.start_date != null && this.form.end_date != null) {
                this.fetchBookingPrice()
            }
        },
        correctDatesSelected() {
            this.show_date_validation_text = false;
            let cabin_prices = this.cabin_prices.filter(element => element.cabin == this.form.cabin);
            let is_blocked_by_peak_season = DateHelper.isBlockedByPeakSeason(this.form.start_date, this.form.end_date, cabin_prices);
            var is_required_length = true;
            if (DateHelper.isHolidayWeek(this.form.start_date, this.form.end_date)) {
                let nr_of_days = DateHelper.getDaysBetweenDates(this.form.start_date, this.form.end_date)
                is_required_length = (nr_of_days % 7 == 0)
            }
            var is_less_than_one_night = (
                this.form.start_date != null &&
                this.form.end_date != null &&
                this.form.start_date === this.form.end_date
            );
            if (is_less_than_one_night) {
                this.date_validation_text = "date_validation_text_minimum"
                this.show_date_validation_text = true;
            } else if (is_blocked_by_peak_season) {
                this.date_validation_text = "date_validation_text_peak_season"
                this.show_date_validation_text = true;
            } else if (!is_required_length) {
                this.date_validation_text = "date_validation_text_holidays"
                this.show_date_validation_text = true;
            }
            return (this.isAdmin || (!is_blocked_by_peak_season && is_required_length));
        },
        async fetchBookingPrice() {
            var user_id = null
            if (this.form.start_date === this.form.end_date) {
                return;
            }
            if (this.bookAsUser) {
                if (this.isAdmin && this.user != null) {
                    user_id = this.user.id;
                } else {
                    user_id = this.$store.getters.user.id;
                }
            }
            this.price_loading = true;
            try {
                const data = await BookingApiService.get_price_for_dates(
                    user_id,
                    this.form.cabin,
                    this.form.start_date.toISOString().split('T')[0],
                    this.form.end_date.toISOString().split('T')[0],
                    this.friends_included,
                );
                this.price = data.data.price
                this.price_loading = false;
            } catch (error) {
                localStorage.clear();
                this.price_loading = false;
            }
        },
        async fetchBookings() {
            this.loading = true;
            try {
                const data = await BookingApiService.get_for_calendar();
                this.bookings = data.data.map(dict => {
                    return new Booking(dict);
                });
                this.loading = false;
                if (this.isAdmin) {
                    this.fetchUsers();
                }
            } catch (error) {
                localStorage.clear();
                this.loading = false;
            }
        },
        async fetchUsers() {
            this.loading = true;
            const params = "order_by=first_name"
            try {
                const data = await UserApiService.get_all(params);
                this.users = this.users.concat(data.data.map(dict => {
                    return {
                        text: dict.first_name + ' ' + dict.last_name + ' - ' + dict.email + ' - ' + dict.phone,
                        value: dict
                    }
                }));
                this.loading = false;
            } catch (error) {
                localStorage.clear();
                this.loading = false;
            }
        },
        async fetchCabinPrices() {
            this.loading_cabin_prices = true;  
            //var params = 'cabin=' + (this.isFamily ? '0' : this.form.cabin)
            try {
                const data = await CabinApiService.get_cabin_prices_full("");
                this.rows = data.data.count
                this.cabin_prices = data.data.map(dict => {
                    return new CabinPrice(dict);
                });
                this.loading_cabin_prices = false;
            } catch (error) {
                this.loading_cabin_prices = false;
            }
        },
        async postBooking() {
            this.loading = true;
            var params = {
                cabin: this.form.cabin,
                start_date: this.form.start_date,
                end_date: this.form.end_date,
                notes: this.form.notes,
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                email: this.form.email,
                phone: this.form.phone,
                has_plus_one: this.friends_included
            };
            if (this.isAdmin) {
                params['price'] = this.price;
            }
            if (this.bookAsUser) {
                if (this.isAdmin && this.user != null) {
                    params['user'] = this.user.id
                } else {
                    params['user'] = this.$store.getters.user.id
                }
            }
            try {
                const data = await BookingApiService.post(params);
                const booking = new Booking(data.data);
                this.loading = false;
                this.$router.push({path: "/booking-confirmation", query: { uuid: booking.uuid }})
            } catch (error) {
                var errorString = this.$t("text.something_went_wrong_try_later")
                if (error.response.status === 400) {
                    errorString = ""
                    for (var key in error.response.data) {
                        errorString += error.response.data[key][0]
                        errorString += " "
                    }
                }
                this.$bvModal.msgBoxOk(errorString, {okVariant: 'danger'})
                this.loading = false;
            }
        },
        onSubmit(event) {
            event.preventDefault();
            this.postBooking();
        },
        goToCabin() {
            if (this.form.cabin == 1) {
                this.$router.push("/large-cabin")
            } else {
                this.$router.push("/small-cabin")
            }
        },
    },
    created() {
        this.fetchBookings();
        var selected_cabin = this.$route.query.cabin
        var start_date = this.$route.query.start_date;
        var end_date = this.$route.query.end_date;
        if (selected_cabin != null) {
            selected_cabin = parseInt(selected_cabin)
            if (selected_cabin == 0) {
                if (!(this.$store.getters.user != null && this.$store.getters.user.clearance > 1)) { return }
            }
            this.form.cabin = selected_cabin;
            this.form_set_from_query = true;
        }

        if (start_date != null) {
            start_date = new Date(start_date);
            if (start_date != null) {
                this.setStartDate(start_date);
                this.form_set_from_query = true;
            }
        }

        if (end_date != null) {
            end_date = new Date(end_date);
            if (end_date != null) {
                this.setEndDate(end_date);
                this.form_set_from_query = true;
            }
        }
    },
}
</script>


<style>
.main {
  height: 100%;
  background-color: #eee;
  text-align: center;
  position: relative;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -ms-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;
}

.body-container {
    text-align: left;
    margin: auto;
    margin-top: -40px;
    max-width: 1000px;
    padding-bottom:40px;
}

.error-label {
    color: #dc3545;
    font-size:14px;
    text-align:center;
    margin-top: 10px;
}

.datepicker__month-day--selected {
    background-color: #4da3ff;
}

.datepicker__month-day--first-day-selected, .datepicker__month-day--last-day-selected {
    background: #4da3ff;
    color: #fff;
    cursor: pointer;
    font-weight: 700;
    pointer-events: auto;
}

.datepicker__month-day--today .datepicker__month-day-wrapper {
    border: 2px solid #4da3ff;
}

.datepicker__month-day-wrapper:hover {
    background-color: #4da3ff;
}

.datepicker__month-button {
    border: 1px solid #424b53;
    
}

.datepicker__month-button--next {
    background: transparent;
}

.datepicker__month-button--next:before{
  color: #424b53;
  content: '➔';
  font-size: 15px;
}

.datepicker__month-button--prev {
    background: transparent;
}

.datepicker__month-button--prev:before{
  color: #424b53;
  content: '➔';
  font-size: 15px;
}

.price-text {
    margin-top: 15px;
}

.booking-section-container {
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    padding: 30px;
    margin-bottom: 100px;
}

.form-section-header-text {
    font-size: 20px;
    font-weight: bold;
}

</style>
